import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import Editor from 'react-medium-editor';
import './medium-editor-styles.css';
import 'medium-editor/dist/css/medium-editor.min.css';
import AutoList from 'medium-editor-autolist/dist/autolist.js';

const autolist = new AutoList();

function isInvalidHTML(html) {
  return !html || html === '' || html === '<p><br></p>' || html === '<p><br /></p>';
}

function filterInvalidHTML(text) {
  return isInvalidHTML(text) ? '' : text;
}

function appendProtocol(text) {
  return /^https?:\/\//.test(text) ? text : 'href="http://' + text + '"';
}

function sanitizeProtocol(text) {
  return text.replace(/href="([^"]+)"/gi, appendProtocol);
}

function getEditorOptions(props) {
  const simpleEditor = props.simpleEditor;
  const placeholder = props.placeholder;
  const options = props.options;
  if (simpleEditor) {
    return {
      // paste: {
      //   cleanPastedHTML: true,
      //   forcePlainText: false
      // },
      targetBlank: true,
      placeholder: {
        hideOnClick: false,
        text: placeholder
      },
      paste: {
        cleanPastedHTML: true,
        cleanAttrs: ['style', 'dir'],
        cleanTags: ['label', 'meta'],
        unwrapTags: ['sub', 'sup']
      },
      toolbar: {
        buttons: [
          'bold',
          'italic',
          // 'superscript', 'subscript',
          // { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
          // { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
          // { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
          { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
        ]
      },
      extensions: { autolist },
      ...options
    };
  }

  return {
    targetBlank: true,
    placeholder: {
      text: placeholder
    },
    paste: {
      cleanPastedHTML: true,
      cleanAttrs: ['style', 'dir'],
      cleanTags: ['label', 'meta'],
      unwrapTags: ['sub', 'sup']
    },
    toolbar: {
      buttons: [
        'bold',
        'italic',
        'h2',
        {
          name: 'anchor',
          contentDefault: '<i class="icon-link-alt"></i>'
        },
        {
          name: 'quote',
          contentDefault: '<i class="icon-quotes-left"></i>'
        },
        {
          name: 'orderedlist',
          contentDefault: '<i class="icon-list-numbered"></i>'
        },
        {
          name: 'unorderedlist',
          contentDefault: '<i class="icon-list2"></i>'
        }
      ]
    },
    ...options
  };
}

export default class MediumEditorWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.value
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      text: nextProps.value
    });
  }

  compose = (value) => {
    this.props.onChange(filterInvalidHTML(value));
  };

  render() {
    const props = this.props;
    const { className, value, onKeyDown, onBlur, onFocus, onClick, placeholder } = props;

    return (
      <div className={className}>
        <Editor
          tag={this.props.tag || undefined}
          ref={component => !!component && (this.editor = component)}
          className="medium-editor medium-editor--custom"
          onChange={this.compose}
          text={this.state.text}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          onFocus={onFocus}
          onClick={onClick}
          placeholder={placeholder}
          value={value}
          options={getEditorOptions(props)}
        />
      </div>
    );
  }
}

MediumEditorWrapper.propTypes = {
  simpleEditor: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  options: PropTypes.object,
  throttleDuration: PropTypes.number
};

MediumEditorWrapper.defaultProps = {
  simpleEditor: false,
  className: 'medium-editor-wrapper',
  value: '',
  placeholder: 'Start Writing',
  onChange: () => {},
  onKeyDown: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClick: () => {},
  options: {},
  throttleDuration: 500
};
